var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLala(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 4275 3100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.226,345.846C281.88,352.532 259.738,373.576 242.726,403.596L192.226,507.595L205.082,426.194C210.316,397.649 183.075,366.64 149.725,370.096L81.225,376.096C58.661,380.141 46.957,392.051 43.725,410.096L0.722,656.094C-4.353,715.032 20.466,746.947 84.724,743.217C148.641,748.307 343.414,623.373 410.724,674.844C437.072,709.833 471.711,699.858 515.724,667.094C543.604,687.791 585.509,683.068 634.724,665.094C744.854,618.438 861.596,559.705 908.725,628.094C923.822,639.637 992.689,627.222 1021.45,565.844C1038.64,514.309 991.887,420.73 953.225,320.095C933.216,285.863 901.067,268.994 861.725,272.095L784.725,283.345C759.143,290.296 741.306,306.139 725.725,331.095L672.724,439.094L682.724,376.095C692.476,330.171 660.513,301.764 612.932,305.674L578.724,309.095C593.04,291.152 592.076,275.704 573.724,263.095C616.208,198.722 649.518,136.729 619.724,91.094C592.832,64.632 553.634,87.828 510.724,122.094C435.837,24.18 364.943,-25.332 300.724,14.094C245.778,54.517 270.358,127.212 307.724,205.095C266.113,263.375 268.836,318.149 312.226,345.846Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.99,337.848C432.657,259.348 507.823,325.098 557.49,287.598C494.812,397.647 449.185,322.352 380.99,337.848Z",
    style: {
      fill: "rgb(2,180,80)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.99,337.848C432.657,259.348 507.823,325.098 557.49,287.598C494.812,397.647 449.185,322.352 380.99,337.848Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.99,337.668C433.823,309.335 505.656,346.431 557.49,287.598C529.7,363.97 474.893,358.98 380.99,337.668Z",
    style: {
      fill: "rgb(0,156,74)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.378,247.673C302.989,292.694 317.933,312.152 361.878,307.173L448.139,286.313C478.594,279.058 479.799,294.053 494.878,295.673C517.378,297.34 622.379,123.506 598.378,110.173C582.878,97.173 547.378,138.173 521.878,152.173C511.741,160.533 499.515,157.731 490.628,142.673C464.698,106.271 435.769,73.62 395.59,44.718C352.806,12.309 293.994,31.247 305.877,84.423C313.961,131.84 345.544,175.256 344.877,198.673C342.794,218.756 327.211,231.34 318.378,247.673ZM407.25,95.423C474.5,136.993 498.344,195.1 500.25,256.673C463.083,200.84 367.917,185.757 349.75,132.423C338.821,92.329 361.262,71.351 407.25,95.423ZM491.248,276.424C471.048,224.309 432.365,209.871 377.498,228.424C347.513,244.958 341.816,277.64 366.748,284.174C408.248,281.591 444.248,258.757 491.248,276.424Z",
    style: {
      fill: "rgb(234,25,33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.747,410.425L128.747,401.926C152.561,397.099 169.201,416.166 161.598,443.088L127.247,620.424C126.224,643.745 139.353,652.52 162.246,643.174C266.516,582.723 342.348,519.398 416.747,551.425L375.39,417.256C371.179,403.27 358.999,404.954 356.122,414.425L307.747,521.924L196.747,589.424L285.497,413.675C292.586,397.235 306.813,380.855 326.247,375.925L388.247,366.925C412.281,364.139 432.546,374.962 443.997,399.176L513.747,573.425L556.497,344.176L610.552,338.479C630.531,337.331 644.684,347.324 642.497,368.675L606.497,552.049C603.755,577.87 624.404,593.772 647.747,578.925C742.608,511.234 832.314,458.18 893.747,485.424L853.137,350.383C846.917,338.415 840.385,338.31 833.498,351.675L787.748,455.924L678.247,525.424L759.497,353.675C769.427,334.13 782.733,315.884 803.332,310.842L868.248,300.925C891.605,297.805 914.725,310.625 926.748,337.175L994.247,508.674C1000.44,526.013 999.516,540.919 989.998,553.924C961.508,577.096 936.942,593.573 925.747,587.424C858.279,517.904 715.999,587.803 586.747,633.424C555.094,638.852 526.687,638.746 516.428,607.735L511.747,608.424C510.492,617.632 507.196,623.226 500.733,628.267C487.738,638.611 454.492,657.58 445.247,651.924C397.404,582.184 243.73,646.179 107.246,699.424C62.579,705.954 25.656,691.069 33.496,641.924L74.747,410.425Z",
    style: {
      fill: "rgb(28,67,142)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.868,574.918C350.701,557.429 393.91,548.037 432.743,577.293L430.868,590.668C397.928,570.409 356.141,568.509 311.868,574.918Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.868,574.918C350.701,557.429 393.91,548.037 432.743,577.293L430.868,590.668C397.928,570.409 356.141,568.509 311.868,574.918Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.868,511.918C832.702,494.429 875.91,485.037 914.744,514.293L912.868,527.668C879.929,507.409 838.142,505.509 793.868,511.918Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.868,511.918C832.702,494.429 875.91,485.037 914.744,514.293L912.868,527.668C879.929,507.409 838.142,505.509 793.868,511.918Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.989,63.417C333.095,27.13 372.022,40.785 415.489,67.917C388.443,46.054 323.248,3.752 310.989,63.417Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.239,121.167L336.361,114.238C338.273,90.748 350.8,77.367 380.713,80.544L391.739,72.167C373.79,65.526 356.355,65.058 339.739,74.417C323.772,83.897 323.829,101.665 327.239,121.167Z",
    style: {
      fill: "rgb(205,29,36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.737,242.169L517.237,261.669L531.237,242.169C523.185,251.181 518.122,251.824 516.737,242.169Z",
    style: {
      fill: "url(#_Linear2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.307,207.353L398.728,211.476C374.465,216.642 354.108,228.719 338.511,249.218L333.057,247.603C340.2,235.935 348.402,225.092 361.557,218.102C377.237,208.676 391.628,206.112 405.307,207.353Z",
    style: {
      fill: "rgb(209,27,34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.262,413.317L628.236,411.669L600.277,568.483C597.736,582.774 609.731,594.424 627.986,591.419C672.819,578.836 723.653,538.752 771.486,512.419C794.541,516.29 810.932,529.048 821.986,548.919C742.653,560.752 691.319,591.586 625.986,612.919C606.504,618.339 592.635,614.498 586.486,597.919C587.319,545.085 609.429,474.65 619.262,413.317Z",
    style: {
      fill: "rgb(8,172,227)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.858,522.915L305.608,514.165L347.608,416.667C357.81,395.343 374.965,392.97 381.358,417.667C396.525,459.999 402.941,488.582 418.108,530.916L470.608,520.416C453.409,478.693 436.211,416.221 419.012,395.249C397.544,371.779 376.076,375.379 354.608,391.917C339.358,406.833 312.108,479.249 290.858,522.915Z",
    style: {
      fill: "rgb(1,163,217)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.857,455.915L784.608,447.165L826.608,349.667C836.811,328.343 853.965,325.97 860.358,350.667C875.525,393 881.941,421.582 897.108,463.916L949.608,453.416C932.409,411.694 915.211,349.222 898.013,328.249C876.544,304.779 855.076,308.379 833.608,324.917C818.358,339.833 791.108,412.25 769.857,455.915Z",
    style: {
      fill: "rgb(4,175,231)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.13,481.31L145.104,479.662L117.145,636.476C114.604,650.768 126.599,662.417 144.854,659.412C189.687,646.829 240.52,606.746 288.354,580.412C311.408,584.283 327.799,597.041 338.854,616.912C259.52,628.745 208.187,659.579 142.854,680.912C123.372,686.332 109.502,682.492 103.354,665.912C104.187,613.079 126.297,542.643 136.13,481.31Z",
    style: {
      fill: "rgb(4,173,229)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.102,275.161C994.285,275.161 1003.35,284.003 1003.35,294.911C1003.35,305.818 994.285,314.66 983.102,314.66C971.918,314.66 962.852,305.818 962.852,294.911C962.852,284.003 971.918,275.161 983.102,275.161Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.102,275.161C994.285,275.161 1003.35,284.003 1003.35,294.911C1003.35,305.818 994.285,314.66 983.102,314.66C971.918,314.66 962.852,305.818 962.852,294.911C962.852,284.003 971.918,275.161 983.102,275.161Z",
    style: {
      fill: "none",
      stroke: "rgb(28,67,140)",
      strokeWidth: "2.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.727,306.136L974.727,283.686L984.667,283.686C986.674,283.686 988.21,283.874 989.245,284.281C990.279,284.689 991.126,285.41 991.722,286.413C992.349,287.448 992.662,288.577 992.662,289.8C992.662,291.399 992.161,292.747 991.126,293.845C990.091,294.911 988.492,295.601 986.36,295.914C987.144,296.29 987.74,296.667 988.147,297.043C988.994,297.827 989.84,298.83 990.593,300.022L994.481,306.136L990.781,306.136L987.802,301.464C986.924,300.116 986.235,299.081 985.67,298.36C985.106,297.639 984.604,297.137 984.165,296.855C983.726,296.573 983.256,296.384 982.785,296.259C982.472,296.196 981.907,296.165 981.155,296.165L977.706,296.165L977.706,306.136L974.727,306.136ZM977.706,293.594L984.071,293.594C985.451,293.594 986.485,293.437 987.269,293.155C988.022,292.904 988.618,292.434 988.994,291.807C989.401,291.211 989.59,290.521 989.59,289.8C989.59,288.734 989.213,287.856 988.429,287.197C987.677,286.508 986.454,286.163 984.792,286.163L977.706,286.163L977.706,293.594Z",
    style: {
      fill: "rgb(28,67,140)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.4844,-11.5115,-11.5115,-12.4844,517.745,257.674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(211,31,37)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(237,28,36)",
      stopOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLala);
export default __webpack_public_path__ + "static/media/Lala.0e24ce21c848340c3c97c9a4b4314e7f.svg";
export { ForwardRef as ReactComponent };